import React from 'react';
import {
  Badge,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const InlineBadge = (props) => {
  const { classes, className, error, ...rest } = props;
  return (
    <div className={className}>
      <Badge
        classes={{ root: classes.root, colorPrimary: error ? classes.colorError : classes.colorPrimary, badge: classes.badge }}
        overlap='rectangular'
        {...rest}
      >
        <div />
      </Badge>
    </div>
  )
}

const styles = theme => ({
  root: {
    position: 'relative',
    display: 'inline-flex',
    margin: '0px 10px',
    // For correct alignment with the text.
    verticalAlign: 'middle',
  },
  colorPrimary: {
    backgroundColor: theme.palette.primary.main, //'#8c8c8c', '#999999'
    color: theme.palette.primary.contrastText,
  },
  colorError: {
    backgroundColor: '#b91919', //'#8c8c8c', '#999999'
    color: theme.palette.primary.contrastText,
  },
  badge: {
    // top: '4px',
  },
});

export default withStyles(styles)(InlineBadge);